import { useEffect } from 'react';

const useScrollReveal = ({ threshold = 0.08, rootMargin = '-20px', oneWay = false } = {}) => {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
          } else if (!oneWay) {
            e.target.classList.remove('is-visible');
          }
        });
      },
      { threshold, rootMargin }
    );
    document.querySelectorAll('[data-scroll]').forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [threshold, rootMargin, oneWay]);
};

export default useScrollReveal;
